import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Resumed from "../common/Resumed";

const CampaignResumed = () => {
  const { log } = React.useContext(LogRenderContext);
  const { campaign } = log.dataSnapshot;
  const {
    campaign: { updatedBy, updatedAt },
  } = log.changedFields;
  const { name, id } = campaign;
  return <Resumed name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default CampaignResumed;
